// extracted by mini-css-extract-plugin
export default {"container":"CombosPanel_container__XWGPv","moreCombos":"CombosPanel_moreCombos__x874x"};